import { render, staticRenderFns } from "./ConsultationScreen.vue?vue&type=template&id=94610296"
import script from "./ConsultationScreen.vue?vue&type=script&lang=js"
export * from "./ConsultationScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports